<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>质安管理</el-breadcrumb-item>
                <el-breadcrumb-item v-if="port==5" :to="{ path: '/proTeam' }">班组信息</el-breadcrumb-item>
                <el-breadcrumb-item>班组人员信息</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all></el-tree>
                <!-- <el-tree :data="dataTree" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
            </div>
            <div class="main-table">
                <div class="table-head">
                    <span>人员检索：</span>
                    <div class="table-head-seach">
                        <el-input placeholder="请输入人员名称" v-model="search.name" class="input-with-select"></el-input>
                    </div>
                    <span style="margin-left:2%;">筛选最近考勤：</span>
                    <div class="table-head-seach" style="width:15%;">
                        <el-input placeholder="请输入天数" v-model="search.dayNumber" class="input-with-select"></el-input>
                    </div>
                    <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin-left:2%;">查询</el-button>
                    <!-- <el-button type="primary" @click="classVisible = true" style="margin-left:3%;">配置{{typeName}}</el-button>
                    <el-button type="primary" @click="outTeam">批量出场</el-button> -->
                </div>
                <div class="table-box">
                    <el-table
                        :data="listData"
                        border
                        height="90%"
                        style="width: 100%;"
                        @selection-change="handleSelectionChange"
                    >
                        <template slot="empty">
                        <p>{{dataText}}</p>
                        </template>
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="序号" width="60">
                        <template slot-scope="scope">
                            <a>{{ scope.row.index}}</a>
                        </template>
                        </el-table-column>
                        <el-table-column label="姓名">
                        <template slot-scope="scope">
                            <a>{{ scope.row.personName}}</a>
                        </template>
                        </el-table-column>
                        <el-table-column label="手机号码">
                        <template slot-scope="scope">
                            <a>{{ scope.row.phone}}</a>
                        </template>
                        </el-table-column>
                        <el-table-column label="身份证号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.idcard }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="性别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex=='1'">男</span>
                            <span v-else-if="scope.row.sex=='2'">女</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column :label="typeName">
                        <template slot-scope="scope">
                            <span>{{ scope.row.workTypeName }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="施工合同">
                        <template slot-scope="scope">
                            <div v-if="scope.row.outFlag=='0'" @click="exportAgree(scope.row)">
                            <img
                                style="width:32px;height:32px;cursor: pointer;"
                                src="../../assets/image/agree.png"
                            />
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column label="门禁卡号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.icCard }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.outFlag=='0'" style="color:#86A0F3">在职</span>
                            <span v-else>已离场</span>
                        </template>
                        </el-table-column>
                        <el-table-column v-if="classType=='3'" label="证书">
                        <template slot-scope="scope">
                            <span
                                v-if="scope.row.certificateNumber&&scope.row.certificateNumber!=''"
                                @click="addCredit(scope.row)"
                            >{{scope.row.certificateNumber}}</span>
                            <!-- <el-button type="primary" icon="el-icon-edit" v-else @click="addCredit(scope.row)"></el-button> -->
                        </template>
                        </el-table-column>
                        <el-table-column label="入职时间" sortable width="180">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="最后一次打卡时间" sortable width="180">
                        <template slot-scope="scope">
                            <span>{{ scope.row.lastDate}}</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                type="text"
                                v-if="scope.row.outFlag=='0'"
                                class="color6"
                                @click="handleDelete(scope.$index, scope.row)"
                                >离场</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>

                    <!-- 分页展示 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 30, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalItems"
                        style="padding-top:10px;"
                    ></el-pagination>

                    <!-- 工种配置 表格-->
                    <!-- <el-dialog
                        width="30%"
                        :title="typeName+'配置'"
                        :append-to-body="true"
                        :lock-scroll="false"
                        :visible.sync="classVisible"
                    >
                        <el-table :data="typeData" height="400" border style="width: 100%">
                        <el-table-column label width="55">
                            <template scope="scope">
                            <el-radio
                                :label="scope.row.value"
                                v-model="workerType"
                                @change.native="getRadioRow(scope.$index,scope.row)"
                            >{{''}}</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column type="index" width="60" label="序号"></el-table-column>
                        <el-table-column prop="label" :label="typeName"></el-table-column>
                        </el-table>
                        <div slot="footer" class="dialog-footer">
                        <el-button @click="classVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitClass()">确 定</el-button>
                        </div>
                    </el-dialog> -->
                    <!-- 人员授权 -->
                    <!-- <el-dialog
                        width="40%"
                        title="管理授权"
                        :append-to-body="true"
                        :lock-scroll="false"
                        :visible.sync="authVisible"
                    >
                        <el-form ref="auth" :model="auth" label-width="120px" :rules="rules">
                        <el-form-item label="活动名称：">
                            <el-input v-model="auth.name" readonly style="width: 200px;"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码：" required prop="phone">
                            <el-input v-model="auth.phone" style="width: 200px;"></el-input>
                        </el-form-item>
                        <el-form-item label="权限选择：">
                            <el-checkbox-group v-model="auth.list">
                            <el-checkbox
                                v-for="item in authList"
                                :key="item.id"
                                :label="item.id"
                            >{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer" style="text-align: center;">
                        <el-button @click="authVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitAuth('auth')">确 定</el-button>
                        </div>
                    </el-dialog> -->
                    <!-- 人员证书 -->
                    <!-- <el-dialog
                        width="500px"
                        title="人员证书"
                        :append-to-body="true"
                        :lock-scroll="false"
                        :visible.sync="credtVisible"
                        class="team-worker-dialog"
                    >
                        <el-form ref="auth" :model="credit" label-width="120px" style="width:500px;">
                        <el-form-item label="姓名：">
                            <el-input v-model="credit.name" readonly style="width: 200px;"></el-input>
                        </el-form-item>
                        <el-form-item label="特种证号：">
                            <el-input v-model="credit.certificateNumber" style="width: 200px;"></el-input>
                        </el-form-item>
                        <el-form-item label="特种证图片：">
                            <el-upload
                            class="avatar-uploader"
                            v-bind:action="uploadImgUrl"
                            :headers="uploadHead"
                            :data="{type:205}"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            >
                            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer" style="text-align: center;">
                        <el-button @click="credtVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sumbitCredit">确 定</el-button>
                        </div>
                    </el-dialog> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],//左侧班组树形结构
            defaultProps:{
                children: 'children',
                 label: 'name'
            },
            classId:'',//当前班组id
            porjectId:'',
            search: {//查询
                name: '',
                dayNumber: ''
            },
            classVisible:false,//配置工种
            uploadUrl: myHttp.importTeamListInfo, //人员导入上传地址
            uploadHead: {
                accessToken: this.$store.state.token
            },
            uploadData: {
                teamsId: ''
            },
            currentPage: 1,//当前页
            pageSize: 10, //每页数量
            totalItems: 0,//总数
            listData: [], //表格数据
            attendVisible: false, //考勤机弹出框
            typeData: [], //考勤设备列表
            //classVisible: false, //班组弹出框
            // classData: [], //班组数据
            // classId: '', //班组id
            classType: '1', //班组类型
            typeName: '工种', //列表和配置类型的名称
            personIdStr: '', //人员选择
            workerType: '', //工种
            authVisible: false, //授权弹出框
            auth: {
                list: [], //授权列表
                name: '',
                phone: ''
            },
            authList: [], //权限列表
            rules: {
                phone: [
                { required: true, message: '请输入手机号码', trigger: 'change' }
                ]
            },
            dataText: '数据加载中...',
            uploadImgUrl: base.url + '/upload/uploadPhoto', //上传图片地址
            credtVisible: false, //特种工作证弹出框
            credit: {
                name: '',
                personId: '',
                teamsId: '',
                id: '',
                certificateNumber: '',
                certificatePhoto: ''
            },
            imageUrl: '',
            projectId: '' ,//图片地址
            port:''
        }
    },
    mounted(){
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.classId = this.$route.params.id
        this.projectId = this.$route.params.proId
        this.uploadData.teamsId = this.classId
        this.port = util.session.get('roleId')
        this.getTeam()
        this.getData()
    },
    methods:{
        /***
         * 获取班组
         */
        getTeam(){
            var that = this
            myHttp.getEntTeams({
                projectId: this.projectId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    for(var i=0;i<list.length;i++){
                        if (list[i].id == that.classId){
                            that.classType = list[i].teamsType
                            that.typeName = that.classType == '2' ? '岗位' : '工种'
                        }
                    }
                    var tree = util.common.listToTree('id', 'parentId', list)
                    // var obj = [{ name: '全部', id: '', parentId: '', children: [] }]
                    // obj[0].children = tree
                    that.dataTree = tree
                    that.getClass(that.classType)
                }
            })
        },
        getClass(){
            var that = this
            if (this.classType == '2') {
                myHttp.getDictByType({
                    type: 'position',
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.typeData = resp.data.data.dictList || []
                    }
                })
            } else if (this.classType == '3') {
                myHttp.getDictByType({
                    type: 'special_type',
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.typeData = resp.data.data.dictList || []
                    }
                })
            } else {
                myHttp.getDictByType({
                    type: 'worktype',
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.typeData = resp.data.data.dictList || []
                    }
                })
            }
        },
        //点击树
        handleNodeClick(data){
            // console.log(data)
            if(!data.isChild){
                this.classId = data.id
                this.uploadData.teamsId = this.classId
                this.classType = data.teamsType
                this.typeName = data.teamsType == '2' ? '岗位' : '工种'
                this.currentPage = 1
                this.getData()
                this.getClass(this.classType)
            }
        },
        //点击查询
        doFilter(){
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //获取人员
        getData(){
            var that = this
            myHttp.getTeamPersonList({
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                teamsId: this.classId,
                personName: this.search.name,
                dayNumber: this.search.dayNumber,
                projectId: this.projectId
            }).then(
                function(resp) {
                    if (resp.data.code == '200') {
                    var list = resp.data.data.pageInfo.list || []
                    for (var i = 0; i < list.length; i++) {
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        
                    }
                    that.listData = list
                    that.totalItems = resp.data.data.pageInfo.total || 0
                    if (that.listData.length == 0) {
                        that.dataText = '暂无数据'
                    }
                    } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                    }
                },
                function() {}
            )
        },

        //人员表格选择
        handleSelectionChange(val) {
            this.personIdStr = ''
            for (var i = 0; i < val.length; i++) {
                if (i == 0) {
                this.personIdStr = val[i].personId
                } else {
                this.personIdStr += ',' + val[i].personId
                }
            }
        },

        //工种选择
        getRadioRow(index, row) {},
        //工种配置
        sumbitClass() {
            var that = this
            myHttp.addWorkType({
                workType: this.workerType,
                idStr: this.personIdStr,
                id: this.classId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message.success('添加工种成功')
                    that.classVisible = false
                    that.getData()
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        },

        //批量出场
        outTeam() {
            var that = this
            if (this.personIdStr == '') {
                that.$message.error('请选择工人！')
                return
            }
            this.$confirm('确认工人离场吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.outTeamsBatch({
                    idStr: that.personIdStr,
                    teamsId: that.classId,
                    operationPerson:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('离场成功')
                    that.getData()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        /**
         * 导出班组人员
         */
        exportOutFun() {
            var token = this.$store.state.token
            window.open(
                myHttp.exportTeamListInfo +
                '?teamsId=' +
                this.classId +
                '&accessToken=' +
                token
            )
        },
        //上传成功监听方法
        handleAppSuccess(res, file) {
            if (res.code == '200') {
                this.$message.success('上传成功')
                this.getData()
            } else {
                this.$message.error(res.msg)
            }
        },
        //个人离场
        // handleDelete(index, row) {
        //     var that = this
        //     this.$confirm('确认该工人' + row.personName + '离场吗?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         myHttp.outTeamsBatch({
        //             idStr: row.personId,
        //             teamsId: that.classId,
        //             operationPerson:util.session.get('user').id
        //         }).then(function(resp) {
        //             if (resp.data.code == '200') {
        //             that.$message.success('离场成功')
        //             that.getData()
        //             } else {
        //             that.$message.error(resp.data.msg)
        //             }
        //         })
        //     })
        // },
        //人员授权
        // handleAutor(index, row) {
        //     this.authVisible = true
        //     this.auth.name = row.personName
        //     this.auth.phone = row.phone
        //     this.auth.personId = row.personId
        //     this.auth.list = []
        //     var that = this
        //     myHttp.getRoleListByProjectId({
        //         projectId: this.search.projectId
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             var list = resp.data.data.roles || []
        //             that.authList = list
        //             that.getWorkerAuth(row.personId)
        //         } else {
        //             that.$message.error(resp.data.msg)
        //         }
        //     })
        // },
        //获取当然人员的权限
        // getWorkerAuth(id) {
        //     var that = this
        //     myHttp.getRoleListByPersonId({
        //         personId: id,
        //         projectId: this.search.projectId
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             var list = resp.data.data.roleList || []
        //             var list1 = []
        //             for (var i = 0; i < list.length; i++) {
        //                 list1.push(list[i].id)
        //             }
        //             that.auth.list = list1
        //         }
        //     })
        // },
        //授权保存
        // sumbitAuth(formName) {
        //     var that = this
        //     this.$refs[formName].validate(valid => {
        //         if (valid) {
        //             var option = {}
        //             option.projectId = that.search.projectId
        //             option.userType = that.$store.state.roleId
        //             option.roleIds = that.auth.list.length > 0 ? that.auth.list.join(',') : ''
        //             option.phone = that.auth.phone
        //             option.name = that.auth.name
        //             option.personId = that.auth.personId
        //             myHttp.authorizePerson(option).then(function(resp) {
        //                 if (resp.data.code == '200') {
        //                     that.authVisible = false
        //                     that.$message.success('授权成功')
        //                     that.getData()
        //                 } else {
        //                     that.$message.error(resp.data.msg)
        //                 }
        //             })
        //         }
        //     })
        // },
        /**
         * 添加证书
         */
        // addCredit(row) {
        //     this.credtVisible = true
        //     this.credit = {
        //         name: row.personName,
        //         personId: row.personId,
        //         id: row.id,
        //         teamsId: this.classId,
        //         certificateNumber: row.certificateNumber,
        //         certificatePhoto: row.certificatePhoto
        //     }
        //     this.imageUrl = row.certificatePhoto
        //         ? base.httpCtx + row.certificatePhoto
        //         : ''
        // },
        /**
         * 上传证书图片
         */
        // handleAvatarSuccess(res, file) {
        //     if (res.code == '200') {
        //         this.$message.success('上传成功')
        //         this.credit.certificatePhoto = res.data.saveUrls
        //         this.imageUrl = base.httpCtx + res.data.saveUrls
        //     } else {
        //         this.$message.error(res.msg)
        //     }
        // },
        /**
         * 证书提交
         */
        // sumbitCredit() {
        //     var that = this
        //     myHttp.updateTeamPerson(this.credit).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             that.credtVisible = false
        //             that.$message.success('操作成功')
        //             that.getData()
        //         } else {
        //             that.$message.error(res.msg)
        //         }
        //     })
        // },

        /**
         * 导出合同
         */
        // exportAgree(row) {
        //     var token = util.session.get('token')
        //     window.open(
        //         myHttp.exportContract +
        //         '?teamsId=' +
        //         this.classId +
        //         '&personId=' +
        //         row.personId +
        //         '&projectId=' +
        //         this.groupId +
        //         '&accessToken=' +
        //         token
        //     )
        // }
    }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
    }
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        overflow: auto;
        background: #fff;
        border-radius: 0.5vh;
        padding: 2vh;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 8vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2vh;
        /* justify-content: space-between; */
    }
    .table-head-seach{
        width: 10%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 8vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
</style>